import api from './api';

export interface TipoProjeto {
  id: string;
  data: TPData;
}

export interface TPData {
  nome: string;
  codigo: number;
}

export const getAllCategorias = () => api.get<TipoProjeto[]>(`tiposprojeto/categorias`);
export const getAllGrupos = () => api.get<TipoProjeto[]>(`tiposprojeto/grupos`);
export const getAllSubGrupos = () => api.get<TipoProjeto[]>(`tiposprojeto/subgrupos`);

export const createCategoria = (tipoProjeto: Omit<TPData, 'codigo'>) =>
  api.post<TipoProjeto>(`tiposprojeto/categorias`, tipoProjeto);

export const createGrupo = (tipoProjeto: Omit<TPData, 'codigo'>) =>
  api.post<TipoProjeto>(`tiposprojeto/grupos`, tipoProjeto);

export const createSubGrupo = (tipoProjeto: Omit<TPData, 'codigo'>) =>
  api.post<TipoProjeto>(`tiposprojeto/subgrupos`, tipoProjeto);

export const updateCategoria = (tipoProjeto: any) => {
  const data = {
    id: tipoProjeto.id,
    nome: tipoProjeto.data.nome,
  };

  return api
    .put<boolean>(`tiposprojeto/categorias/${data.id}`, data)
    .then(result => true)
    .catch(err => false);
};

export const updateGrupo = (tipoProjeto: any) => {
  const data = {
    id: tipoProjeto.id,
    nome: tipoProjeto.data.nome,
  };

  return api
    .put<boolean>(`tiposprojeto/grupos/${data.id}`, data)
    .then(result => true)
    .catch(err => false);
};

export const updateSubGrupo = (tipoProjeto: any) => {
  const data = {
    id: tipoProjeto.id,
    nome: tipoProjeto.data.nome,
  };

  return api
    .put<boolean>(`tiposprojeto/subgrupos/${data.id}`, data)
    .then(result => true)
    .catch(err => false);
};

export const deleteCategoria = (id: string) => api.delete(`tiposprojeto/categorias/${id}`);
export const deleteGrupo = (id: string) => api.delete(`tiposprojeto/grupos/${id}`);
export const deleteSubGrupo = (id: string) => api.delete(`tiposprojeto/subgrupos/${id}`);
